import axiosClient from '../axiosClient';

const reportService = {
  async getPhotoStats(payload) {
    const response = await axiosClient.post('/report/photo-stats', payload);
    return response.data;
  },
  async getPhotoStatsXlsx(payload) {
    return axiosClient.post('/report/photo-stats/export', payload, {
      responseType: 'blob',
    });
  },
  async getPhotoStatsDoc(payload) {
    return axiosClient.post('/report/photo-stats/export-doc', payload, {
      responseType: 'blob',
    });
  },  
};

export default reportService;
